import { useMemo, useLayoutEffect, useEffect } from 'react';
import canUseDOM from '../../utils/canUseDOM/dac5c056569482021accf87fd538ecc27d8fd0c72464de839f0931e17633376c.cfe-internal.js';

var useSSRLayoutEffect = function useSSRLayoutEffect() {
  var effectFunc = useMemo(function () {
    return canUseDOM() ? useLayoutEffect : useEffect;
  }, []);
  return effectFunc.apply(void 0, arguments);
};

var useSSRLayoutEffect$1 = useSSRLayoutEffect;

export { useSSRLayoutEffect$1 as default };
